<template lang="pug">
.rr-loading
  img(src='../assets/loading.png' alt="loklok loading")
</template>

<script>
export default {
  name: 'rr-loading-placeholder'
}
</script>

<style lang="sass" scoped>
@import '../styles/index'
.rr-loading
  width: 100%
  padding: 30px 0
  text-align: center
  img
    width: 22px
    height: 22px
    animation: rotation 1s linear infinite
@keyframes rotation
  from
    -webkit-transform: rotate(0deg)
  to
    -webkit-transform: rotate(360deg)
</style>
